import PropTypes from 'prop-types';
import React from 'react';
import Reflux from 'reflux';
import { Button, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { DocumentTitle, PageHeader, Spinner } from 'components/common';

import DocsHelper from 'util/DocsHelper';
import Routes from 'routing/Routes';

import ArchiveBackendConfigForm from 'components/ArchiveBackendConfigForm';
import ArchiveLicenseStatusContainer from 'components/ArchiveLicenseStatusContainer';
import ArchiveActions from 'ArchiveActions';
import ArchiveStore from 'ArchiveStore';

const ArchiveBackendConfigurationPage = React.createClass({
  propTypes: {
    params: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  },

  mixins: [
    Reflux.connect(ArchiveStore),
  ],

  getInitialState() {
    return {
      backend: undefined,
    };
  },

  componentDidMount() {
    if (this.props.params.backendId) {
      ArchiveActions.getBackend(this.props.params.backendId);
    }
  },

  _checkOutputPath(path) {
    return ArchiveActions.checkOutputTemplate(path);
  },

  _updateConfiguration(backend) {
    ArchiveActions.saveBackend(backend).then(() => {
      this.props.history.pushState(null, Routes.pluginRoute('SYSTEM_ARCHIVES_BACKENDS'));
    });
  },

  _isLoading() {
    return this.props.params.backendId && !this.state.backend;
  },

  render() {
    if (this._isLoading()) {
      return <Spinner />;
    }

    let backend = this.state.backend;
    if (!this.props.params.backendId) {
      // TODO: Should not be hardcoded!
      backend = {
        title: '',
        description: '',
        settings: {
          type: 'fs-1',
          output_path: '',
        },
      };
    }

    return (
      <DocumentTitle title="Archive backend configuration">
        <div>
          <PageHeader title="Edit archive backend configuration">
            <span>
              The Graylog archive feature allows you to create archives from indices. The generated archives
              are simple flat files that can be moved to cheap storage and re-imported at any time.
            </span>
            <span>
              Archive your old indices automatically by setting your index retention strategy to archive
              on the{' '} <LinkContainer to={Routes.SYSTEM.INDICES.LIST}><a>indices</a></LinkContainer>{' '}
              page.
            </span>
            <span>
              <LinkContainer to={Routes.pluginRoute('SYSTEM_ARCHIVES')}>
                <Button bsStyle="info">Overview</Button>
              </LinkContainer>
              &nbsp;
              <LinkContainer to={Routes.pluginRoute('SYSTEM_ARCHIVES_CONFIGURATION')}>
                  <Button bsStyle="info">Configuration</Button>
                </LinkContainer>
              &nbsp;
              <LinkContainer to={Routes.pluginRoute('SYSTEM_ARCHIVES_BACKENDS')}>
                  <Button bsStyle="info" className="active">Manage Backends</Button>
              </LinkContainer>
            </span>
          </PageHeader>
          <ArchiveLicenseStatusContainer />
          <Row className="content">
            <Col lg={12}>
              <ArchiveBackendConfigForm backend={backend}
                                        checkOutputPath={this._checkOutputPath}
                                        updateConfiguration={this._updateConfiguration}
                                        cancelURL={Routes.pluginRoute('SYSTEM_ARCHIVES_BACKENDS')} />
            </Col>
          </Row>
        </div>
      </DocumentTitle>
    );
  },
});

export default ArchiveBackendConfigurationPage;



// WEBPACK FOOTER //
// ./src/web/ArchiveBackendConfigurationPage.jsx